<template>
  <Loader v-if="!isDataLoaded"/>
  <div v-else>
    <Agility
      v-for="vcenter in vsphere"
      :key="vcenter.id"
      :name="vcenter.vcenter"
      :replicated="vcenter.protected"
      :vms="vcenter.vms"
      :cpu="vcenter.cpu"
      :memory="vcenter.memory"
      :storage="vcenter.storage"
      :hide-problems="true"/>

    <Table
      :title="$t('views.agilityMonitoring.title')"
      :is_search="false"
      :headers="problemsHeaders"
      :rows="problemsRows"
      :values="problems"/>
  </div>
</template>

<script>
import VSPHERE from '@/api/vsphere';
import PROBLEMS from '@/api/problems';

import Loader from '@/components/Loader.vue';
import Table from '@/components/Table.vue';
import ProgressGroupAgility from '@/components/ProgressGroupAgility.vue';

export default {
  name: 'agilityMonitoring',
  components: {
    Agility: ProgressGroupAgility,
    Table,
    Loader,
  },
  data() {
    return {
      vsphere: null,
      problemsHeaders: [
        {
          label: this.$t('views.agilityMonitoring.config.problemsHeaders.time'),
          field: 'time',
        },
        {
          label: this.$t('views.agilityMonitoring.config.problemsHeaders.host'),
          field: 'host',
        },
        {
          label: this.$t('views.agilityMonitoring.config.problemsHeaders.name'),
          field: 'name',
        },
        {
          label: this.$t('views.agilityMonitoring.config.problemsHeaders.duration'),
          field: 'duration',
        },
      ],
      problemsRows: [
        {
          value: row => row.time,
          link: row => ({
            href: row.url,
            alt: 'Agility problems',
            target: '_blank',
          }),
        },
        {
          value: row => row.host,
          link: row => ({
            href: row.url,
            alt: 'Agility problems',
            target: '_blank',
          }),
          color: row => 'gray-700',
        },
        {
          value: row => row.name,
          link: row => ({
            href: row.url,
            alt: 'Agility problems',
            target: '_blank',
          }),
          color: (row) => {
            switch (row.severity) {
              case 'Warning':
                return 'warning';
              case 'Average':
                return 'warning';
              case 'High':
                return 'danger';
              case 'Disaster':
                return 'danger';
              default:
                return 'success';
            }
          },
        },
        {
          value: row => row.duration,
          link: row => ({
            href: row.url,
            alt: 'Agility problems',
            target: '_blank',
          }),
        },
      ],
      problems: [],
    }
  },
  created() {
    this.getVsphereTotal();
    this.getProblems();
  },
  computed: {
    isDataLoaded() {
      return (this.vsphere && this.problems);
    },
  },
  methods: {
    getVsphereTotal() {
      VSPHERE.total().then((res) => {
        if (res && res.data) {
          this.vsphere = res.data;
        }
      });
    },
    getProblems() {
      PROBLEMS.list().then((res) => {
        if (res.data && res.data.length) {
          this.problems = res.data;
        }
      });
    },
  },
};
</script>
